/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-05-18T12:09:52.309
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listStockpileIntentionAttachment,
	listStockpileIntentionAttachmentInit,
	listStockpileIntentionAttachmentByAuthorizations,
	deleteStockpileIntentionAttachment
	
} from '@api/storagemanage/StockpileIntentionAttachment';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listStockpileIntentionAttachment({
			state
		}) {
			return new Promise((resolve, reject) => {
				listStockpileIntentionAttachment(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listStockpileIntentionAttachmentByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listStockpileIntentionAttachmentByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listStockpileIntentionAttachmentInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listStockpileIntentionAttachmentInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteStockpileIntentionAttachment({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteStockpileIntentionAttachment({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
